import React from "react";
import { ColumnDefinition } from "../../table/ColumnDefinitionNew";

export type TableMode = 'grid' | 'list';
export interface IPageRequest { Skip: number; Take: number; }
export interface IPaginator {
  quantity: number;
  mainPage: number;
  modifyMainPage: (value: number) => void;
  pageRequest: IPageRequest;
}
export interface SmartTableConfig {
  mode?: TableMode;
  pageSize?: number;
  blockSize: number;
  paginator?: IPaginator;
  storageKey?: string;// opcional para persistir selección
  defaultVisibleCount?: number;
  defaultColumns?: string[];
  debugMode?: boolean; // opcional, logs útiles
  isCustomizeTableAvailable?:boolean;
  filterControl?:React.ReactNode;
  title?: string
}
export type SmartType = 'text' | 'number' | 'date' | 'boolean' | 'arrayString';
export interface SmartColumn {
  key: string;
  label: string;
  type: SmartType;
  def: ColumnDefinition;
}
export type ColumnGroup = {
  categoryLabel: string;     // label del grupo (viene de def.category)
  items: SmartColumn[];      // columnas del grupo
};
export interface SmartTableProps {
  data: any[];
  config?: SmartTableConfig;
  columnDefinitions: ColumnDefinition[];
  onDownload?: () => void;
  onDownloadOptions?: Array<{ label: string; icon?: React.ReactNode; onClick: () => void }>;
  /** obtener siguiente Paginado y reemplazar en el contenedor */
  onFetchMore?: () => void;
  openRangeFilter?: () => void;
  clearFilters?: () => void;
  extraFilter?: React.ReactNode;
  dateRangeType?: React.ReactNode;
}

export interface IFilterControlState {
  textValue: string,
  selectedValue: string,
  numberValue: string,
}
export interface IActiveColumn {
  selectedValue: string,
}

export const EmptyFilterControlState: IFilterControlState = {
  textValue: '',
  selectedValue: '',
  numberValue: '',
}
export type SortDirection = 'asc' | 'desc' | undefined;
export interface SortState { key?: string; direction?: SortDirection; }
export const MIN_COLUMN_WIDTH_PX = 120;